import React from "react";

import { t } from "i18next";

import { Markdown } from "@/components/atoms";

import { TTask } from "@/types";

export const TaskView: React.FC<{ task?: Pick<TTask, "workedOn"> }> = ({
	task,
}) => {
	if (!task) return null;

	return (
		<>
			{!task.workedOn?.length && (
				<p className="text-neutral-400">{t("tasks.noDescription")}</p>
			)}
			<Markdown>{task.workedOn}</Markdown>
		</>
	);
};
